import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { ptBR } from "@mui/x-date-pickers/locales";

function GenericDatePicker(props) {
  const {
    label,
    value,
    onChange,
    placeholder,
    required,
    error,
    helperText,
    variant,
    slotProps: slotPropsParent,
    ...rest
  } = props;

  const handleChange = (dayJSdate) => {
    const dateVal = dayJSdate ? dayJSdate.toDate() : null;
    onChange(dateVal);
  };

  const parentTextField = slotPropsParent?.textField || {};
  const textFieldSlot = {
    size: "small",
    fullWidth: true,
    error: !!error,
    variant: variant || "outlined",
    helperText:
      helperText === "Invalid date" ? "Data inválida" : helperText,
    ...parentTextField,
    sx: [
      {
        overflow: "visible",
        "& .MuiFormControl-root": { overflow: "visible" },
        "& .MuiInputLabel-root": { overflow: "visible" },
      },
      ...(Array.isArray(parentTextField.sx)
        ? parentTextField.sx
        : parentTextField.sx
          ? [parentTextField.sx]
          : []),
    ],
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-br"
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DatePicker
        slotProps={{
          ...slotPropsParent,
          textField: textFieldSlot,
        }}
        label={label.concat(required ? " *" : "")}
        size="small"
        format="DD/MM/YYYY"
        value={
          value !== undefined
            ? dayjs(value)
              ? dayjs(value)
              : null
            : null
        }
        onChange={handleChange}
        placeholder={placeholder}
        {...rest}
      />
    </LocalizationProvider>
  );
}

export default GenericDatePicker;
